define('OutSystems/ClientRuntime/modules/Database/IndexedDB/IndexedDBTransaction',["require", "exports", "tslib", "../../../Logger", "../TableInfoUtils", "./IndexedDBTransactionWithoutObjectStores", "./IndexedDBUtils"], function (require, exports, tslib_1, Logger, TableInfoUtils, IndexedDBTransactionWithoutObjectStores_1, IndexedDBUtils_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var TRANSACTION_ID_MAX = 1000000000000;
    var IndexedDBTransaction = (function (_super) {
        tslib_1.__extends(IndexedDBTransaction, _super);
        function IndexedDBTransaction(allowTraces, transaction, database) {
            var _this = _super.call(this, allowTraces, database) || this;
            _this.transaction = transaction;
            IndexedDBTransaction.lastTransactionId = (IndexedDBTransaction.lastTransactionId + 1) % TRANSACTION_ID_MAX;
            _this.transactionId = IndexedDBTransaction.lastTransactionId + 1;
            return _this;
        }
        Object.defineProperty(IndexedDBTransaction.prototype, "onComplete", {
            set: function (handler) {
                var _this = this;
                this.transaction.oncomplete = function () {
                    if (_this.allowTraces) {
                        Logger.trace(_this, "Committing transaction ".concat(_this.transactionId));
                    }
                    return handler();
                };
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(IndexedDBTransaction.prototype, "onAbort", {
            set: function (handler) {
                var _this = this;
                this.transaction.onabort = function () {
                    if (_this.allowTraces) {
                        Logger.trace(_this, "Aborting transaction ".concat(_this.transactionId, ": ").concat(_this.transaction.error));
                    }
                    return handler(_this.transaction.error);
                };
            },
            enumerable: false,
            configurable: true
        });
        IndexedDBTransaction.prototype.executeQuery = function (body) {
            return body(this.transaction);
        };
        IndexedDBTransaction.prototype.renameTable = function (tableName, newTableName) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var store;
                return tslib_1.__generator(this, function (_a) {
                    store = this.transaction.objectStore(tableName);
                    store.name = newTableName;
                    return [2];
                });
            });
        };
        IndexedDBTransaction.prototype.getRecord = function (table, key) {
            var _this = this;
            return new Promise(function (resolve, reject) {
                _this.trace("Getting record with keys '".concat(key, "' from table '").concat(table.tableName, "'"));
                var store = _this.transaction.objectStore(table.tableName);
                var getRequest = store.get(IndexedDBTransaction.wrapKeyIfNeeded(key, table));
                getRequest.onsuccess = function () {
                    _this.trace("Retrieved record with keys '".concat(key, "' from table '").concat(table.tableName, "' successfully"));
                    resolve((getRequest.result || null));
                };
                getRequest.onerror = function (evt) {
                    _this.trace("Error retrieving record with keys '".concat(key, "' from table '").concat(table.tableName, "'"), _this.transaction.error);
                    (0, IndexedDBUtils_1.markEventAsHandled)(evt);
                    reject(_this.transaction.error);
                };
            });
        };
        IndexedDBTransaction.prototype.removeRecord = function (table, key) {
            var _this = this;
            return new Promise(function (resolve, reject) {
                _this.trace("Deleting record with key '".concat(key, "' from table '").concat(table.tableName, "'"));
                var store = _this.transaction.objectStore(table.tableName);
                var deleteRequest = store.delete(IndexedDBTransaction.wrapKeyIfNeeded(key, table));
                deleteRequest.onsuccess = function () {
                    _this.trace("Deleted record with key '".concat(key, "' from table '").concat(table.tableName, "' successfully"));
                    resolve();
                };
                deleteRequest.onerror = function (evt) {
                    _this.trace("Error deleting record with key '".concat(key, "' from table '").concat(table.tableName, "'"), deleteRequest.error);
                    (0, IndexedDBUtils_1.markEventAsHandled)(evt);
                    reject(deleteRequest.error);
                };
            });
        };
        IndexedDBTransaction.prototype.removeAllRecords = function (table) {
            var _this = this;
            return new Promise(function (resolve, reject) {
                _this.trace("Deleting all records from table '".concat(table.tableName, "'"));
                var store = _this.transaction.objectStore(table.tableName);
                var clearRequest = store.clear();
                clearRequest.onsuccess = function () {
                    _this.trace("Deleted all records from table '".concat(table.tableName, "' successfully"));
                    resolve();
                };
                clearRequest.onerror = function (evt) {
                    _this.trace("Error deleting all records from table '".concat(table.tableName, "'"), clearRequest.error);
                    (0, IndexedDBUtils_1.markEventAsHandled)(evt);
                    reject(clearRequest.error);
                };
            });
        };
        IndexedDBTransaction.prototype.insertRecord = function (table, record) {
            var _this = this;
            return new Promise(function (resolve, reject) {
                _this.trace("Inserting record on table '".concat(table.tableName, "'"));
                var addResult = _this.transaction.objectStore(table.tableName).add(record);
                addResult.onsuccess = function () {
                    _this.trace("Inserted record on table '".concat(table.tableName, "' successfully"));
                    resolve(IndexedDBTransaction.unwrapKeyIfNeeded(addResult));
                };
                addResult.onerror = function (evt) {
                    _this.trace("Error inserting record on table '".concat(table.tableName, "'"), addResult.error);
                    (0, IndexedDBUtils_1.markEventAsHandled)(evt);
                    reject(addResult.error);
                };
            });
        };
        IndexedDBTransaction.prototype.upsertRecord = function (table, record) {
            var _this = this;
            return new Promise(function (resolve, reject) {
                _this.trace("Adding/Updating record on table '".concat(table.tableName, "'"));
                var putResult = _this.transaction.objectStore(table.tableName).put(record);
                putResult.onsuccess = function () {
                    _this.trace("Added/Updated record on table '".concat(table.tableName, "' successfully"));
                    resolve(IndexedDBTransaction.unwrapKeyIfNeeded(putResult));
                };
                putResult.onerror = function (evt) {
                    _this.trace("Error adding/updating record on table '".concat(table.tableName, "'"), putResult.error);
                    (0, IndexedDBUtils_1.markEventAsHandled)(evt);
                    reject(putResult.error);
                };
            });
        };
        IndexedDBTransaction.prototype.upsertAllRecords = function (table, records) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var _i, records_1, record, error_1;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.trace("Adding/updating ".concat(records === null || records === void 0 ? void 0 : records.length, " record(s) on table '").concat(table.tableName, "'"));
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 6, , 7]);
                            _i = 0, records_1 = records;
                            _a.label = 2;
                        case 2:
                            if (!(_i < records_1.length)) return [3, 5];
                            record = records_1[_i];
                            return [4, this.upsertRecord(table, record)];
                        case 3:
                            _a.sent();
                            _a.label = 4;
                        case 4:
                            _i++;
                            return [3, 2];
                        case 5:
                            this.trace("Added/updated ".concat(records === null || records === void 0 ? void 0 : records.length, " record(s) on table '").concat(table.tableName, "' successfully"));
                            return [3, 7];
                        case 6:
                            error_1 = _a.sent();
                            this.trace("Error adding/updating ".concat(records === null || records === void 0 ? void 0 : records.length, " record(s) on table '").concat(table.tableName, "'"), error_1);
                            throw error_1;
                        case 7: return [2];
                    }
                });
            });
        };
        IndexedDBTransaction.prototype.updateRecord = function (table, record) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var _this = this;
                return tslib_1.__generator(this, function (_a) {
                    return [2, new Promise(function (resolve, reject) {
                            var primaryColumns = TableInfoUtils.getIdentifierColumnNames(table);
                            if (primaryColumns.length === 0) {
                                var error = new Error("Cannot perform an update on table '".concat(table.tableName, "' since it has no primary key column"));
                                _this.trace(error.message);
                                return reject(error);
                            }
                            _this.trace("Checking if record exists on table '".concat(table.tableName, "'"));
                            var getResult = _this.transaction
                                .objectStore(table.tableName)
                                .get(primaryColumns.map(function (name) { return record[name]; }));
                            getResult.onsuccess = function () {
                                try {
                                    if (!getResult.result) {
                                        var error = new Error("Record to update does not exist on table '".concat(table.tableName, "'"));
                                        _this.trace(error.message);
                                        return reject(error);
                                    }
                                    _this.trace("Updating record on table '".concat(table.tableName, "'"));
                                    var putResult_1 = _this.transaction.objectStore(table.tableName).put(record);
                                    putResult_1.onsuccess = function () {
                                        _this.trace("Updated record on table '".concat(table.tableName, "' successfully"));
                                        resolve();
                                    };
                                    putResult_1.onerror = function (evt) {
                                        _this.trace("Error updating record on table '".concat(table.tableName, "'"), putResult_1.error);
                                        (0, IndexedDBUtils_1.markEventAsHandled)(evt);
                                        reject(putResult_1.error);
                                    };
                                }
                                catch (error) {
                                    _this.trace("Error updating record on table '".concat(table.tableName, "'"), error);
                                    reject(error);
                                }
                            };
                            getResult.onerror = function (evt) {
                                _this.trace("Error checking if record exists on table '".concat(table.tableName, "'"), getResult.error);
                                (0, IndexedDBUtils_1.markEventAsHandled)(evt);
                                reject(getResult.error);
                            };
                        })];
                });
            });
        };
        IndexedDBTransaction.prototype.addColumn = function (table, column) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var allRecords, _i, allRecords_1, record;
                var _this = this;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, new Promise(function (resolve, reject) {
                                _this.trace("Adding column '".concat(Logger.serializeObjectForLog(column), "' on table '").concat(table.tableName, "'"));
                                try {
                                    _this.transaction.objectStore(table.tableName).createIndex(column.columnName, column.columnName);
                                    resolve();
                                }
                                catch (error) {
                                    _this.trace("Error adding column '".concat(Logger.serializeObjectForLog(column), "' on table '").concat(table.tableName, "'"), error);
                                    reject(error);
                                }
                            })];
                        case 1:
                            _a.sent();
                            return [4, this.getAllRecords(table)];
                        case 2:
                            allRecords = _a.sent();
                            _i = 0, allRecords_1 = allRecords;
                            _a.label = 3;
                        case 3:
                            if (!(_i < allRecords_1.length)) return [3, 6];
                            record = allRecords_1[_i];
                            record[column.columnName] = column.serializedDefault;
                            return [4, this.upsertRecord(table, record)];
                        case 4:
                            _a.sent();
                            _a.label = 5;
                        case 5:
                            _i++;
                            return [3, 3];
                        case 6: return [2];
                    }
                });
            });
        };
        IndexedDBTransaction.prototype.existsColumn = function (tableName, columnName) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var _this = this;
                return tslib_1.__generator(this, function (_a) {
                    return [2, new Promise(function (resolve, reject) {
                            _this.trace("Checking if column '".concat(columnName, "' exists on table '").concat(tableName, "'"));
                            try {
                                var exists = _this.transaction.objectStoreNames.contains(tableName) &&
                                    _this.transaction.objectStore(tableName).indexNames.contains(columnName);
                                resolve(exists);
                            }
                            catch (error) {
                                _this.trace("Error checking if column '".concat(columnName, "' exists on table '").concat(tableName, "'"), error);
                                reject(error);
                            }
                        })];
                });
            });
        };
        IndexedDBTransaction.prototype.findRecords = function (table, criteria) {
            var _this = this;
            return new Promise(function (resolve, reject) {
                _this.trace("Searching for all records on table '".concat(table.tableName, "' that match the specified criteria."));
                var result = [];
                var hasPrimaryKey = TableInfoUtils.getIdentifierColumns(table).length > 0 ? true : false;
                var store = _this.transaction.objectStore(table.tableName);
                var cursorRequest = store.openCursor();
                cursorRequest.onsuccess = function () {
                    var cursor = cursorRequest.result;
                    if (cursor) {
                        var record_1 = cursor.value;
                        if (!hasPrimaryKey) {
                            record_1 = tslib_1.__assign(tslib_1.__assign({}, record_1), { $KEY: cursor.primaryKey });
                        }
                        var isMatch = Object.keys(criteria).reduce(function (previousValue, key) {
                            return previousValue &&
                                criteria.hasOwnProperty(key) &&
                                record_1[TableInfoUtils.formatObjectName(key)] === criteria[key];
                        }, true);
                        if (isMatch) {
                            result.push(record_1);
                        }
                        cursor.continue();
                    }
                    else {
                        _this.trace("Search on table '".concat(table.tableName, "' found ").concat(result.length, " record(s) matching the specified criteria."));
                        resolve(result);
                    }
                };
                cursorRequest.onerror = function (evt) {
                    _this.trace("Error searching for records on table '".concat(table.tableName, "'"), cursorRequest.error);
                    (0, IndexedDBUtils_1.markEventAsHandled)(evt);
                    reject(cursorRequest.error);
                };
            });
        };
        IndexedDBTransaction.prototype.getAllRecords = function (table) {
            var _this = this;
            return new Promise(function (resolve, reject) {
                _this.trace("Getting all records from table '".concat(table.tableName, "'"));
                var store = _this.transaction.objectStore(table.tableName);
                var getAllRequest = store.getAll();
                getAllRequest.onsuccess = function () {
                    _this.trace("Retrieved all the records from table '".concat(table.tableName, "'"));
                    resolve(getAllRequest.result);
                };
                getAllRequest.onerror = function (evt) {
                    _this.trace("Error retrieving all the records from table '".concat(table.tableName, "'"), getAllRequest.error);
                    (0, IndexedDBUtils_1.markEventAsHandled)(evt);
                    reject(getAllRequest.error);
                };
            });
        };
        IndexedDBTransaction.wrapKeyIfNeeded = function (key, table) {
            var hasPrimaryKey = TableInfoUtils.getIdentifierColumns(table).length > 0;
            if (hasPrimaryKey) {
                return key instanceof Array ? key : [key];
            }
            else {
                return key;
            }
        };
        IndexedDBTransaction.unwrapKeyIfNeeded = function (request) {
            return request.result instanceof Array
                ? request.result[0]
                : request.result;
        };
        IndexedDBTransaction.lastTransactionId = 0;
        return IndexedDBTransaction;
    }(IndexedDBTransactionWithoutObjectStores_1.default));
    exports.default = IndexedDBTransaction;
});
//# sourceMappingURL=IndexedDBTransaction.js.map;
